import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
// import Processing from "../../components/processing/processing";
import { useLocation } from "react-router-dom";
import { API } from "../../api/api";
import constants from '../../utils/contants';

const VehicleTab = () => {

    const [isEditable, setIsEditable] = useState(false);
    const [buttonValue, setButtonValue] = useState("Edit");
    const { state } = useLocation();
    const { driver } = state;
    useEffect(() => {
        getUserData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getUserData = () => {
        // setLoading(true);
        formik.setFieldValue("carname", driver?.car_info?.car_type?.name);
        formik.setFieldValue("carnumber", driver?.car_info?.car_number);
        formik.setFieldValue("carcolor", driver?.car_info?.car_color);
        formik.setFieldValue("caryear", driver?.car_info?.car_year);
        formik.setFieldValue("carseat", driver?.car_info?.car_no_of_seat);
        // setLoading(false);
    };

    const validationSchema = Yup.object().shape({
        carname: Yup.string().required("Please Enter Username"),
        carnumber: Yup.string().required("Please Enter Username"),
        carcolor: Yup.string().required("Please Enter email"),
        caryear: Yup.number().required().positive().integer(),
        carseat: Yup.string().required("Please Enter Vehicle"),
    });

    const formik = useFormik({
        initialValues: {
            carname: "",
            carnumber: "",
            carcolor: "",
            caryear: "",
            carseat: ""
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            const body = {
                // id: driver?._id,
                car_info: {
                    car_type: {
                        name: values?.carname,
                    },
                    car_year: values?.caryear,
                    car_color: values?.carcolor,
                    car_number: values?.carnumber,
                    car_no_of_seat: values?.carseat,
                },
            };
            API(`update-driver/${driver?._id}`, "put", body, localStorage.getItem(constants.TOKEN))
                .then((res) => {
                    toast.success("Driver Details updated successfully ✅", {
                        position: toast.POSITION.TOP_RIGHT,
                        className: "bg-success text-white",
                    });
                    // navigate("/manage-driver");
                })
                .catch((error) => {
                    toast.error("Error while updating Driver Details", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    console.log("error: ", error);
                });
        },
    });

    const enableEditing = () => {
        setIsEditable(true);
        setButtonValue("Update");
    };



    return (
        <>
            <hr className="mt-4" />
            <div className="advice_form text-black select_visible">
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Car Name</label>
                    <input
                        type="text"
                        name="carname"
                        disabled={isEditable ? false : true}
                        className="form form-control bg-transparent text-black"
                        // {...formik.getFieldProps("username")}
                        value={formik.values.carname}
                        onChange={(e) => {
                            formik.setFieldValue("carname", e.target.value?.trimStart())
                        }}
                    />
                    {formik.touched.car_info?.car_type?.name && formik.errors.car_info?.car_type?.name && (
                        <div className="text-danger">{formik.errors.car_info?.car_type?.name}</div>
                    )}
                </div>
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Car Number</label>
                    <input
                        type="text"
                        name="carnumber"
                        disabled={isEditable ? false : true}
                        className="form form-control bg-transparent text-black"
                        // {...formik.getFieldProps("username")}
                        value={formik.values.carnumber || ''}
                        onChange={(e) => {
                            formik.setFieldValue("carnumber", e.target.value?.trimStart())
                        }}
                    />
                    {formik.touched.car_info?.car_number && formik.errors.car_info?.car_number && (
                        <div className="text-danger">{formik.errors.car_info?.car_number}</div>
                    )}
                </div>
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Car Color</label>
                    <input
                        type="text"
                        name="carcolor"
                        disabled={isEditable ? false : true}
                        className="form form-control bg-transparent text-black type_password"
                        // {...formik.getFieldProps("email")}
                        value={formik.values.carcolor || ''}
                        onChange={(e) => {
                            formik.setFieldValue("carcolor", e.target.value?.trimStart())
                        }}
                    />
                    {formik.touched.car_info?.car_color && formik.errors.emcar_info?.car_color && (
                        <div className="text-danger">{formik.errors.car_info?.car_color}</div>
                    )}
                </div>
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Year</label>
                    <input
                        type="text"
                        name="caryear"
                        disabled={isEditable ? false : true}
                        className="form form-control bg-transparent text-black"
                        // {...formik.getFieldProps("username")}
                        value={formik.values.caryear || ''}
                        onChange={(e) => {
                            formik.setFieldValue("caryear", e.target.value?.trimStart())
                        }}
                    />
                    {formik.touched.car_info?.car_number && formik.errors.car_info?.car_number && (
                        <div className="text-danger">{formik.errors.car_info?.car_number}</div>
                    )}
                </div>
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Seat</label>
                    <input
                        type="text"
                        name="carseat"
                        disabled={isEditable ? false : true}
                        className="form form-control bg-transparent text-black type_password"
                        // {...formik.getFieldProps("email")}
                        value={formik.values.carseat || ''}
                        onChange={(e) => {
                            formik.setFieldValue("carseat", e.target.value?.trimStart())
                        }}
                    />
                    {formik.touched.car_info?.car_no_of_seat && formik.errors.car_info?.car_no_of_seat && (
                        <div className="text-danger">{formik.errors.car_info?.car_no_of_seat}</div>
                    )}
                </div>
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Photo</label>
                    <input
                        type="text"
                        name="email"
                        disabled={isEditable ? false : true}
                        className="form form-control bg-transparent text-black type_password"
                        // {...formik.getFieldProps("email")}
                        value={formik.values.email}
                        onChange={(e) => {
                            formik.setFieldValue("email", e.target.value?.trimStart())
                        }}
                    />
                    {formik.touched.email && formik.errors.email && (
                        <div className="text-danger">{formik.errors.email}</div>
                    )}
                </div>
                <div className="d-flex mt-5 justify-content-end gap-4">
                    <button
                        type="button"
                        className="form_button btn advice__category"
                        onClick={() => {
                            window.history.back();
                        }}
                    >
                        Back
                    </button>
                    <button
                        type="button"
                        className="form_button btn advice__category"
                        disabled={
                            buttonValue === "Update" &&
                            formik.values.carname === driver?.car_info?.car_type?.name &&
                            formik.values.carnumber === driver?.car_info?.car_number &&
                            formik.values.caryear === driver?.car_info?.car_year &&
                            formik.values.carcolor === driver?.car_info?.car_color &&
                            formik.values.carseat === driver?.car_info?.car_no_of_seat
                        }
                        onClick={
                            buttonValue === "Update" ? formik.handleSubmit : enableEditing
                        }
                    >
                        {buttonValue}
                    </button>
                </div>
            </div>
        </>
    )
}

export default VehicleTab